import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { type ModalComponentProps } from '@atlassian/entry-points/modal-context-provider';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ModalFixtureComponent = EntryPointComponent<
	Record<string, never>,
	Record<string, never>,
	ModalComponentProps,
	Record<string, never>
>;

export const modalEntryPoint: EntryPoint<ModalFixtureComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<ModalFixtureComponent>(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-points/ModalEntryPointFixture" */ './modal-ui.tsx'
			) as unknown as Promise<{ default: ModalFixtureComponent }>, // I honestly don't get why this has to be done but it does
		{
			moduleId: 'modal-entry-point',
		},
	),
	getPreloadProps: () => ({}),
});
